export default "__VITE_ASSET__BkXNbnX5__"